import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold font-heading text-background-50 mb-4">
              盛世娱乐
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汇聚全球顶尖娱乐内容，致力于为用户提供极致、安全、便捷的高端娱乐体验。您的满意，是我们不懈的追求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              娱乐分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="/about#contact"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  联系我们
                </a>
              </li>
              <li>
                <a
                  href="/about#faq"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              联系方式
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-300">support@shengshientertainment.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-300">400-888-9999</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-300">7×24小时在线客服</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 盛世娱乐 版权所有 | 致力于打造安全可靠的娱乐平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                用户协议
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                责任娱乐
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}